import isEmpty from 'lodash/isEmpty';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TextButton from '@spothero/ui/text-button';
import DOMUtils from '@spothero/utils/dom';
import {
    showRateDetails,
    toggleOversizedFeeDetails,
    toggleOnlineCommuterDetails,
} from 'spot/spot-actions';

class Disclaimers extends PureComponent {
    static propTypes = {
        selectedRate: PropTypes.object.isRequired,
        isMonthly: PropTypes.bool.isRequired,
        hasOversizedFee: PropTypes.bool.isRequired,
        vehicleSelectPresent: PropTypes.bool.isRequired,
        supportsOversizeFeeType: PropTypes.bool.isRequired,
        vehicleRestriction: PropTypes.string,
        onShowRateDetailsClick: PropTypes.func.isRequired,
        onOversizedFeeDetailsClick: PropTypes.func.isRequired,
        onOnlineCommuterRateClick: PropTypes.func.isRequired,
    };

    _onIntroRateClick = evt => {
        evt.preventDefault();

        this.props.onShowRateDetailsClick(
            DOMUtils.attr(evt.currentTarget, 'data-section')
        );
    };

    _renderTransient = () => {
        const {
            selectedRate,
            hasOversizedFee,
            vehicleRestriction,
            vehicleSelectPresent,
            supportsOversizeFeeType,
            onOnlineCommuterRateClick,
            onOversizedFeeDetailsClick,
        } = this.props;
        let feeMessage = '';

        if (
            hasOversizedFee &&
            vehicleRestriction &&
            !vehicleSelectPresent &&
            !supportsOversizeFeeType
        ) {
            feeMessage = 'Vehicle restrictions and fees.';
        } else if (
            hasOversizedFee &&
            !vehicleSelectPresent &&
            !supportsOversizeFeeType
        ) {
            feeMessage = 'Oversized fee charged on site.';
        } else if (vehicleRestriction) {
            feeMessage = 'Vehicle restrictions apply.';
        }

        return (
            <span>
                {selectedRate.online_commuter_rate && (
                    <span className="Disclaimers-disclaimer online-commuter-rate">
                        <span className="Disclaimers-disclaimer-text">
                            Enter between{' '}
                            {selectedRate.online_commuter_rate_enter_start}-
                            {selectedRate.online_commuter_rate_enter_end} to
                            receive this price.
                        </span>
                        &nbsp;
                        <TextButton onClick={onOnlineCommuterRateClick}>
                            Details
                        </TextButton>
                    </span>
                )}
                {!isEmpty(feeMessage) && (
                    <span className="Disclaimers-disclaimer oversize-fee">
                        <span className="Disclaimers-disclaimer-text">
                            {feeMessage}
                        </span>
                        &nbsp;
                        <TextButton onClick={onOversizedFeeDetailsClick}>
                            Details
                        </TextButton>
                    </span>
                )}
            </span>
        );
    };

    _renderMonthly = () => {
        const {selectedRate} = this.props;

        if (selectedRate.introductory && selectedRate.introductory.rate) {
            return (
                <span className="Disclaimers-disclaimer">
                    <span className="Disclaimers-disclaimer-text">
                        Intro Rate.
                    </span>
                    &nbsp;
                    <TextButton
                        className="Disclaimers-disclaimer-action"
                        data-section="intro-rate"
                        onClick={this._onIntroRateClick}
                    >
                        Details
                    </TextButton>
                </span>
            );
        } else {
            return null;
        }
    };

    render() {
        const {isMonthly} = this.props;

        return (
            <div className="Disclaimers">
                {!isMonthly ? this._renderTransient() : this._renderMonthly()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        checkout: {vehicleSelectPresent, supportsOversizeFeeType},
        searchRequest: {monthly: isMonthly},
        spot: {
            selected: {selectedRate, hasOversizedFee, vehicleRestriction},
        },
    } = state;

    return {
        selectedRate,
        vehicleSelectPresent,
        supportsOversizeFeeType,
        isMonthly,
        hasOversizedFee,
        vehicleRestriction,
    };
};

const mapDispatchToProps = {
    onShowRateDetailsClick: showRateDetails,
    onOversizedFeeDetailsClick: toggleOversizedFeeDetails,
    onOnlineCommuterRateClick: toggleOnlineCommuterDetails,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Disclaimers);
